export const colors = {
  brandPrimaryDefault: "#ff8300",
  brandPrimaryTint: "#FFE5D1",
  brandPrimaryShade: "#8E4918",
  brandGradientDefault: "linear-gradient(125deg, #052855 0%, #052855 100%)",
  brandGradientColorStopsStart: "#052855",
  brandGradientColorStopsEnd: "#052855",
  productColorsPrimaryL5: "#FFF2E8",
  productColorsPrimaryL4: "#FFE5D1",
  productColorsPrimaryL3: "#FFCBA5",
  productColorsPrimaryL2: "#FFB07A",
  productColorsPrimaryL1: "#FF954E",
  productColorsPrimary: "#ff8300",
  productColorsPrimaryD1: "#C2611A",
  productColorsPrimaryD2: "#8E4918",
  productColorsPrimaryD3: "#5E3214",
  productColorsPrimaryD4: "#311D0E",
  contentBrandPrimary: "#ff8300",
  backgroundBrand: "#ff8300",
  borderBrand: "#ff8300",
  componentButtonPrimaryContentBase: "#0a0a0a",
  componentButtonPrimaryContentHover: "#0a0a0a",
  componentButtonPrimaryContentActive: "#0a0a0a",
  componentButtonPrimaryBackgroundBase: "#ff8300",
  componentButtonPrimaryBackgroundHover: "#C2611A",
  componentButtonPrimaryBackgroundActive: "#8E4918",
  componentButtonPrimaryBorderBase: "#ff8300",
  componentButtonPrimaryBorderHover: "#C2611A",
  componentButtonPrimaryBorderActive: "#8E4918",
};

export const text = {
  themeName: "Mohegan Sun",
};